import { Answer } from '../../models/questionnaire.model';
import { User } from '../../models/user.model';

// ============================================================================
// V1 - Configuração Legada (mantida para compatibilidade)
// ============================================================================

export interface FillInfoConfigV1 {
  version?: 1; // Opcional - se não tiver version, assume V1
  from: string; // Tabela alvo
  update: string; // Coluna a atualizar
  updateType?: 'string' | 'jsonb'; // Tipo de update (default: 'string')
  valueSource?: 'value' | 'addtional_information'; // De onde pegar valor (default: 'value')
  jsonKey?: string; // Se updateType=jsonb, qual chave
  filters: Array<{
    op: string; // Operador (só 'eq' implementado)
    col: string; // Coluna do filtro
    val: string; // Valor (suporta $userId)
  }>;
}

// ============================================================================
// V2 - Nova Configuração Segura
// ============================================================================

export type FillInfoTarget = 'profile'; // Extensível: | 'claim' | 'document'

export type FillInfoTransform = 
  | 'uppercase' 
  | 'lowercase' 
  | 'trim'
  | 'capitalize';

export interface FillInfoConfigV2 {
  version: 2;
  target: FillInfoTarget;
  field: string; // Campo flat do target
  valueSource?: 'value' | 'addtional_information'; // default: 'value'
  transform?: FillInfoTransform; // Transformação opcional
  /** CPK-5059: com KYC aprovado e o campo já preenchido, a pergunta mostra o cadastro e não edita. */
  lockWhenKycPassed?: boolean;
}

// ============================================================================
// Union Type - Suporta ambas versões
// ============================================================================

export type FillInfoConfig = FillInfoConfigV1 | FillInfoConfigV2;

// ============================================================================
// Input para processamento
// ============================================================================

export interface FillInfoProcessInput {
  config: FillInfoConfig;
  answer: Answer;
  user: User;
}

// ============================================================================
// Campos permitidos por target (V2)
// ============================================================================

export const ALLOWED_PROFILE_FIELDS = [
  'first_name',
  'surname',
  'date_of_birth',
  'legal_name', // Deprecado mas aceito
  'id_document_type',
  'id_document_value',
  'contacts', // JSONB
  'primary_address', // JSONB
] as const;

export type AllowedProfileField = typeof ALLOWED_PROFILE_FIELDS[number];
